[
  {
    "task": "TowelHang",
    "episode": 1,
    "durationGain": 15.09,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 2,
    "durationGain": 26.41,
    "coverageGain": 50.0
  },
  {
    "task": "TowelHang",
    "episode": 3,
    "durationGain": 0.0,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 4,
    "durationGain": 27.21,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 5,
    "durationGain": 26.23,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 6,
    "durationGain": 26.67,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 7,
    "durationGain": 22.69,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 8,
    "durationGain": 18.26,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 9,
    "durationGain": 21.9,
    "coverageGain": 100.0
  },
  {
    "task": "TowelHang",
    "episode": 10,
    "durationGain": 22.15,
    "coverageGain": 100.0
  },
  {
    "task": "TowelHang",
    "episode": 11,
    "durationGain": 23.77,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 12,
    "durationGain": 17.23,
    "coverageGain": 100.0
  },
  {
    "task": "TowelHang",
    "episode": 13,
    "durationGain": 23.91,
    "coverageGain": 50.0
  },
  {
    "task": "TowelHang",
    "episode": 14,
    "durationGain": 21.53,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 15,
    "durationGain": 25.68,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 16,
    "durationGain": 26.33,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 17,
    "durationGain": 23.25,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 18,
    "durationGain": 23.97,
    "coverageGain": 50.0
  },
  {
    "task": "TowelHang",
    "episode": 19,
    "durationGain": 21.58,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 20,
    "durationGain": 21.42,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 21,
    "durationGain": 20.18,
    "coverageGain": 25.0
  },
  {
    "task": "TowelHang",
    "episode": 22,
    "durationGain": 21.85,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 23,
    "durationGain": 24.21,
    "coverageGain": 100.0
  },
  {
    "task": "TowelHang",
    "episode": 24,
    "durationGain": 25.09,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 25,
    "durationGain": 26.99,
    "coverageGain": 100.0
  },
  {
    "task": "TowelHang",
    "episode": 26,
    "durationGain": 19.98,
    "coverageGain": 50.0
  },
  {
    "task": "TowelHang",
    "episode": 27,
    "durationGain": 15.46,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 28,
    "durationGain": 18.2,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 29,
    "durationGain": 27.62,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 30,
    "durationGain": 16.46,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 31,
    "durationGain": 0.61,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 32,
    "durationGain": 22.45,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 33,
    "durationGain": 21.06,
    "coverageGain": 33.3333
  },
  {
    "task": "TowelHang",
    "episode": 34,
    "durationGain": 23.42,
    "coverageGain": 100.0
  },
  {
    "task": "TowelHang",
    "episode": 35,
    "durationGain": 14.75,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 36,
    "durationGain": 20.11,
    "coverageGain": 50.0
  },
  {
    "task": "TowelHang",
    "episode": 37,
    "durationGain": 17.39,
    "coverageGain": 50.0
  },
  {
    "task": "TowelHang",
    "episode": 38,
    "durationGain": 16.22,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 39,
    "durationGain": 19.01,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 40,
    "durationGain": 0.0,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 41,
    "durationGain": 18.76,
    "coverageGain": 50.0
  },
  {
    "task": "TowelHang",
    "episode": 42,
    "durationGain": 20.24,
    "coverageGain": 50.0
  },
  {
    "task": "TowelHang",
    "episode": 43,
    "durationGain": 25.01,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 44,
    "durationGain": 16.94,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 45,
    "durationGain": 19.94,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 46,
    "durationGain": 0.0,
    "coverageGain": 66.6667
  },
  {
    "task": "TowelHang",
    "episode": 47,
    "durationGain": 23.52,
    "coverageGain": 66.6667
  },
  {
    "task": "BinTowel",
    "episode": 1,
    "durationGain": 29.83,
    "coverageGain": 47.0588
  },
  {
    "task": "BinTowel",
    "episode": 2,
    "durationGain": 23.7,
    "coverageGain": 50.0
  },
  {
    "task": "BinTowel",
    "episode": 3,
    "durationGain": 24.55,
    "coverageGain": 50.0
  },
  {
    "task": "BinTowel",
    "episode": 4,
    "durationGain": 32.18,
    "coverageGain": 44.4444
  },
  {
    "task": "BinTowel",
    "episode": 5,
    "durationGain": 26.39,
    "coverageGain": 50.0
  },
  {
    "task": "BinTowel",
    "episode": 6,
    "durationGain": 29.5,
    "coverageGain": 44.4444
  },
  {
    "task": "BinTowel",
    "episode": 7,
    "durationGain": 29.96,
    "coverageGain": 36.8421
  },
  {
    "task": "BinTowel",
    "episode": 8,
    "durationGain": 23.27,
    "coverageGain": 26.6667
  },
  {
    "task": "BinTowel",
    "episode": 9,
    "durationGain": 26.03,
    "coverageGain": 37.5
  },
  {
    "task": "BinTowel",
    "episode": 10,
    "durationGain": 19.71,
    "coverageGain": 33.3333
  },
  {
    "task": "BinTowel",
    "episode": 11,
    "durationGain": 23.13,
    "coverageGain": 33.3333
  },
  {
    "task": "BinTowel",
    "episode": 12,
    "durationGain": 29.22,
    "coverageGain": 37.5
  },
  {
    "task": "BinTowel",
    "episode": 13,
    "durationGain": 29.83,
    "coverageGain": 50.0
  },
  {
    "task": "BinTowel",
    "episode": 14,
    "durationGain": 24.43,
    "coverageGain": 58.8235
  },
  {
    "task": "BinTowel",
    "episode": 15,
    "durationGain": 22.43,
    "coverageGain": 38.8889
  },
  {
    "task": "BinTowel",
    "episode": 16,
    "durationGain": 4.07,
    "coverageGain": 33.3333
  },
  {
    "task": "BinTowel",
    "episode": 17,
    "durationGain": 24.35,
    "coverageGain": 36.8421
  },
  {
    "task": "BinTowel",
    "episode": 18,
    "durationGain": 25.51,
    "coverageGain": 44.4444
  },
  {
    "task": "BinTowel",
    "episode": 19,
    "durationGain": 21.9,
    "coverageGain": 58.8235
  },
  {
    "task": "BinTowel",
    "episode": 20,
    "durationGain": 23.01,
    "coverageGain": 33.3333
  },
  {
    "task": "BinTowel",
    "episode": 21,
    "durationGain": 28.67,
    "coverageGain": 44.4444
  },
  {
    "task": "BinTowel",
    "episode": 22,
    "durationGain": 24.02,
    "coverageGain": 25.0
  },
  {
    "task": "BinTowel",
    "episode": 23,
    "durationGain": 19.4,
    "coverageGain": 33.3333
  },
  {
    "task": "BinTowel",
    "episode": 24,
    "durationGain": 8.52,
    "coverageGain": 33.3333
  },
  {
    "task": "BinTowel",
    "episode": 25,
    "durationGain": 22.4,
    "coverageGain": 38.8889
  },
  {
    "task": "BinTowel",
    "episode": 26,
    "durationGain": 21.8,
    "coverageGain": 50.0
  },
  {
    "task": "BinTowel",
    "episode": 27,
    "durationGain": 22.9,
    "coverageGain": 37.5
  },
  {
    "task": "BinTowel",
    "episode": 28,
    "durationGain": 26.22,
    "coverageGain": 38.8889
  },
  {
    "task": "BinTowel",
    "episode": 29,
    "durationGain": 25.12,
    "coverageGain": 50.0
  },
  {
    "task": "BinTowel",
    "episode": 30,
    "durationGain": 25.3,
    "coverageGain": 44.4444
  },
  {
    "task": "ToteCards",
    "episode": 1,
    "durationGain": -0.62,
    "coverageGain": 50.0
  },
  {
    "task": "ToteCards",
    "episode": 2,
    "durationGain": -0.63,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 3,
    "durationGain": -0.62,
    "coverageGain": 50.0
  },
  {
    "task": "ToteCards",
    "episode": 4,
    "durationGain": -0.62,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 5,
    "durationGain": -0.63,
    "coverageGain": 50.0
  },
  {
    "task": "ToteCards",
    "episode": 6,
    "durationGain": -0.62,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 7,
    "durationGain": -0.63,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 8,
    "durationGain": -0.64,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 9,
    "durationGain": -0.64,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 10,
    "durationGain": -0.5,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 11,
    "durationGain": -0.63,
    "coverageGain": 50.0
  },
  {
    "task": "ToteCards",
    "episode": 12,
    "durationGain": -1.7,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 13,
    "durationGain": -0.5,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 14,
    "durationGain": -0.65,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 15,
    "durationGain": -0.59,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 16,
    "durationGain": -0.63,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 17,
    "durationGain": -0.64,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 18,
    "durationGain": -1.66,
    "coverageGain": 50.0
  },
  {
    "task": "ToteCards",
    "episode": 19,
    "durationGain": -0.63,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 20,
    "durationGain": -0.63,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 21,
    "durationGain": -0.63,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 22,
    "durationGain": -0.65,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 23,
    "durationGain": -0.62,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 24,
    "durationGain": -0.5,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 25,
    "durationGain": -1.2,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 26,
    "durationGain": -0.5,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 27,
    "durationGain": -0.25,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 28,
    "durationGain": -1.91,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 29,
    "durationGain": -0.64,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 30,
    "durationGain": -1.25,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 31,
    "durationGain": -0.65,
    "coverageGain": 50.0
  },
  {
    "task": "ToteCards",
    "episode": 32,
    "durationGain": -0.63,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 33,
    "durationGain": -0.62,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 34,
    "durationGain": -0.61,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 35,
    "durationGain": -0.62,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 36,
    "durationGain": -0.66,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 37,
    "durationGain": -0.62,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 38,
    "durationGain": -2.18,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 39,
    "durationGain": -0.63,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 40,
    "durationGain": -1.87,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 41,
    "durationGain": -0.62,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 42,
    "durationGain": -0.62,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 43,
    "durationGain": -0.63,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 44,
    "durationGain": -0.62,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 45,
    "durationGain": -4.83,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 46,
    "durationGain": -0.62,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 47,
    "durationGain": -0.66,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 48,
    "durationGain": -0.62,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 49,
    "durationGain": -0.63,
    "coverageGain": 100.0
  },
  {
    "task": "ToteCards",
    "episode": 50,
    "durationGain": -0.63,
    "coverageGain": 100.0
  },
  {
    "task": "BagTape",
    "episode": 1,
    "durationGain": 7.28,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 2,
    "durationGain": 7.36,
    "coverageGain": 27.2727
  },
  {
    "task": "BagTape",
    "episode": 3,
    "durationGain": 8.39,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 4,
    "durationGain": 2.3,
    "coverageGain": 27.2727
  },
  {
    "task": "BagTape",
    "episode": 5,
    "durationGain": 6.09,
    "coverageGain": 8.3333
  },
  {
    "task": "BagTape",
    "episode": 6,
    "durationGain": 6.63,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 7,
    "durationGain": 7.64,
    "coverageGain": 8.3333
  },
  {
    "task": "BagTape",
    "episode": 8,
    "durationGain": 6.32,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 9,
    "durationGain": 5.72,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 10,
    "durationGain": 5.86,
    "coverageGain": 8.3333
  },
  {
    "task": "BagTape",
    "episode": 11,
    "durationGain": 5.47,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 12,
    "durationGain": 6.54,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 13,
    "durationGain": 5.73,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 14,
    "durationGain": 5.94,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 15,
    "durationGain": 5.86,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 16,
    "durationGain": 6.05,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 17,
    "durationGain": 7.74,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 18,
    "durationGain": 6.71,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 19,
    "durationGain": 5.66,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 20,
    "durationGain": 5.78,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 21,
    "durationGain": 6.6,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 22,
    "durationGain": 5.87,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 23,
    "durationGain": 6.28,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 24,
    "durationGain": 5.93,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 25,
    "durationGain": 7.31,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 26,
    "durationGain": 4.99,
    "coverageGain": 8.3333
  },
  {
    "task": "BagTape",
    "episode": 27,
    "durationGain": 6.06,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 28,
    "durationGain": -1.03,
    "coverageGain": 18.1818
  },
  {
    "task": "BagTape",
    "episode": 29,
    "durationGain": 6.47,
    "coverageGain": 16.6667
  },
  {
    "task": "BagTape",
    "episode": 30,
    "durationGain": 5.08,
    "coverageGain": 16.6667
  },
  {
    "task": "LidEraser",
    "episode": 1,
    "durationGain": 6.82,
    "coverageGain": 56.25
  },
  {
    "task": "LidEraser",
    "episode": 2,
    "durationGain": 4.74,
    "coverageGain": 62.5
  },
  {
    "task": "LidEraser",
    "episode": 3,
    "durationGain": 9.71,
    "coverageGain": 47.0588
  },
  {
    "task": "LidEraser",
    "episode": 4,
    "durationGain": 9.59,
    "coverageGain": 64.7059
  },
  {
    "task": "LidEraser",
    "episode": 5,
    "durationGain": 14.25,
    "coverageGain": 76.4706
  },
  {
    "task": "LidEraser",
    "episode": 6,
    "durationGain": 12.85,
    "coverageGain": 82.3529
  },
  {
    "task": "LidEraser",
    "episode": 7,
    "durationGain": 13.27,
    "coverageGain": 52.9412
  },
  {
    "task": "LidEraser",
    "episode": 8,
    "durationGain": 12.58,
    "coverageGain": 58.8235
  },
  {
    "task": "LidEraser",
    "episode": 9,
    "durationGain": 13.43,
    "coverageGain": 50.0
  },
  {
    "task": "LidEraser",
    "episode": 10,
    "durationGain": 13.54,
    "coverageGain": 50.0
  },
  {
    "task": "LidEraser",
    "episode": 11,
    "durationGain": 13.37,
    "coverageGain": 52.9412
  },
  {
    "task": "LidEraser",
    "episode": 12,
    "durationGain": 13.01,
    "coverageGain": 44.4444
  },
  {
    "task": "LidEraser",
    "episode": 13,
    "durationGain": 13.71,
    "coverageGain": 44.4444
  },
  {
    "task": "LidEraser",
    "episode": 14,
    "durationGain": 14.44,
    "coverageGain": 55.5556
  },
  {
    "task": "LidEraser",
    "episode": 15,
    "durationGain": 14.9,
    "coverageGain": 50.0
  },
  {
    "task": "LidEraser",
    "episode": 16,
    "durationGain": 16.03,
    "coverageGain": 50.0
  },
  {
    "task": "LidEraser",
    "episode": 17,
    "durationGain": 13.3,
    "coverageGain": 50.0
  },
  {
    "task": "LidEraser",
    "episode": 18,
    "durationGain": 14.07,
    "coverageGain": 44.4444
  },
  {
    "task": "LidEraser",
    "episode": 19,
    "durationGain": 16.73,
    "coverageGain": 66.6667
  },
  {
    "task": "LidEraser",
    "episode": 20,
    "durationGain": 16.34,
    "coverageGain": 61.1111
  },
  {
    "task": "LidEraser",
    "episode": 21,
    "durationGain": 13.73,
    "coverageGain": 61.1111
  },
  {
    "task": "LidEraser",
    "episode": 22,
    "durationGain": 12.93,
    "coverageGain": 38.8889
  },
  {
    "task": "LidEraser",
    "episode": 23,
    "durationGain": 11.64,
    "coverageGain": 44.4444
  },
  {
    "task": "LidEraser",
    "episode": 24,
    "durationGain": 12.2,
    "coverageGain": 44.4444
  },
  {
    "task": "LidEraser",
    "episode": 25,
    "durationGain": 13.87,
    "coverageGain": 44.4444
  },
  {
    "task": "LidEraser",
    "episode": 26,
    "durationGain": 12.27,
    "coverageGain": 66.6667
  },
  {
    "task": "LidEraser",
    "episode": 27,
    "durationGain": 11.02,
    "coverageGain": 44.4444
  },
  {
    "task": "LidEraser",
    "episode": 28,
    "durationGain": 10.7,
    "coverageGain": 44.4444
  },
  {
    "task": "LidEraser",
    "episode": 29,
    "durationGain": 11.46,
    "coverageGain": 50.0
  },
  {
    "task": "LidEraser",
    "episode": 30,
    "durationGain": 13.82,
    "coverageGain": 61.1111
  },
  {
    "task": "TrayWipe",
    "episode": 1,
    "durationGain": 0.01,
    "coverageGain": 63.6364
  },
  {
    "task": "TrayWipe",
    "episode": 2,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 3,
    "durationGain": -0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 4,
    "durationGain": 0.16,
    "coverageGain": 45.4545
  },
  {
    "task": "TrayWipe",
    "episode": 5,
    "durationGain": 1.45,
    "coverageGain": 72.7273
  },
  {
    "task": "TrayWipe",
    "episode": 6,
    "durationGain": -0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 7,
    "durationGain": -0.0,
    "coverageGain": 63.6364
  },
  {
    "task": "TrayWipe",
    "episode": 8,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 9,
    "durationGain": 0.0,
    "coverageGain": 75.0
  },
  {
    "task": "TrayWipe",
    "episode": 10,
    "durationGain": 0.0,
    "coverageGain": 72.7273
  },
  {
    "task": "TrayWipe",
    "episode": 11,
    "durationGain": -0.01,
    "coverageGain": 72.7273
  },
  {
    "task": "TrayWipe",
    "episode": 12,
    "durationGain": 0.0,
    "coverageGain": 81.8182
  },
  {
    "task": "TrayWipe",
    "episode": 13,
    "durationGain": 0.0,
    "coverageGain": 81.8182
  },
  {
    "task": "TrayWipe",
    "episode": 14,
    "durationGain": 0.05,
    "coverageGain": 72.7273
  },
  {
    "task": "TrayWipe",
    "episode": 15,
    "durationGain": 0.0,
    "coverageGain": 63.6364
  },
  {
    "task": "TrayWipe",
    "episode": 16,
    "durationGain": 0.0,
    "coverageGain": 72.7273
  },
  {
    "task": "TrayWipe",
    "episode": 17,
    "durationGain": 0.26,
    "coverageGain": 81.8182
  },
  {
    "task": "TrayWipe",
    "episode": 18,
    "durationGain": 0.0,
    "coverageGain": 81.8182
  },
  {
    "task": "TrayWipe",
    "episode": 19,
    "durationGain": -0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 20,
    "durationGain": 0.01,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 21,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 22,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 23,
    "durationGain": 0.0,
    "coverageGain": 72.7273
  },
  {
    "task": "TrayWipe",
    "episode": 24,
    "durationGain": -0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 25,
    "durationGain": 0.0,
    "coverageGain": 72.7273
  },
  {
    "task": "TrayWipe",
    "episode": 26,
    "durationGain": 0.0,
    "coverageGain": 63.6364
  },
  {
    "task": "TrayWipe",
    "episode": 27,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 28,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 29,
    "durationGain": -0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 30,
    "durationGain": 0.0,
    "coverageGain": 50.0
  },
  {
    "task": "TrayWipe",
    "episode": 31,
    "durationGain": -0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 32,
    "durationGain": 0.05,
    "coverageGain": 63.6364
  },
  {
    "task": "TrayWipe",
    "episode": 33,
    "durationGain": -0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 34,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 35,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 36,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 37,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 38,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 39,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 40,
    "durationGain": 0.03,
    "coverageGain": 63.6364
  },
  {
    "task": "TrayWipe",
    "episode": 41,
    "durationGain": 0.0,
    "coverageGain": 50.0
  },
  {
    "task": "TrayWipe",
    "episode": 42,
    "durationGain": 0.0,
    "coverageGain": 63.6364
  },
  {
    "task": "TrayWipe",
    "episode": 43,
    "durationGain": 0.3,
    "coverageGain": 63.6364
  },
  {
    "task": "TrayWipe",
    "episode": 44,
    "durationGain": 0.05,
    "coverageGain": 63.6364
  },
  {
    "task": "TrayWipe",
    "episode": 45,
    "durationGain": 0.06,
    "coverageGain": 72.7273
  },
  {
    "task": "TrayWipe",
    "episode": 46,
    "durationGain": 0.0,
    "coverageGain": 63.6364
  },
  {
    "task": "TrayWipe",
    "episode": 47,
    "durationGain": 0.21,
    "coverageGain": 36.3636
  },
  {
    "task": "TrayWipe",
    "episode": 48,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 49,
    "durationGain": 0.0,
    "coverageGain": 54.5455
  },
  {
    "task": "TrayWipe",
    "episode": 50,
    "durationGain": 0.0,
    "coverageGain": 81.8182
  }
]
